// extracted by mini-css-extract-plugin
export default {"flavors_title":"Yba","no_selected_flavors":"Zba","success":"aca","select_flavors_wrapper":"bca","flavors_select":"cca","custom_select_control":"eca","opened":"fca","subtitle":"gca","selected_flavors":"hca","selected_flavor_item":"ica","selected_flavor_item_image":"jca","selected_flavor_item_title":"kca","selected_flavor_item_qty":"lca","drawer_header":"mca"};
    if(module.hot) {
      // 1738836199126
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  